var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-paper",class:[
    _vm.paperStyle ? 'r-paper--' + _vm.paperStyle : '',
    {
      'r-paper--round': _vm.round,
    },
  ],on:{"click":_vm.clickHandler}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }